
export interface DatabaseChangesOptions {
    databaseName: string;
    nodeTag: string;
}
